/**
 * A enum representing the surface of an SD UI view
 */
export enum DisplayPageType {
  DISPLAY_PAGE_TYPE_UNKNOWN = 'DISPLAY_PAGE_TYPE_UNKNOWN',
  HOMEPAGE = 'HOMEPAGE',
  CATEGORY_PAGE = 'CATEGORY_PAGE',
  PRODUCT_PAGE = 'PRODUCT_PAGE',
  CART_PAGE = 'CART_PAGE',
  SIMILAR_PRODUCTS_PAGE = 'SIMILAR_PRODUCTS_PAGE',
  SEARCH_PAGE = 'SEARCH_PAGE',
  DIGEST_PAGE = 'DIGEST_PAGE',
  BRAND_DETAILS_PAGE = 'BRAND_DETAILS_PAGE',
  BROWSE_LANDING_PAGE = 'BROWSE_LANDING_PAGE',
  SEO_DISCOVER_PAGE = 'SEO_DISCOVER_PAGE',
  SITE_WIDE_TOP_OF_PAGE = 'SITE_WIDE_TOP_OF_PAGE',
  SEE_MORE_PAGE = 'SEE_MORE_PAGE',
  SEARCH_SUGGESTIONS_EMPTY_PAGE = 'SEARCH_SUGGESTIONS_EMPTY_PAGE',
}
